module.exports = __webpack_public_path__ + "img/banner1_3.e1b22761.png";